// start of judgeme app 
// This script finds the elements and appends the body inside the header
document.addEventListener("DOMContentLoaded", function() {
  var header = document.querySelector('.jdgm-rev-widg__header');
  var body = document.querySelector('.jdgm-rev-widg__body');

  // Check if both elements exist before trying to append
  if (header && body) {
    header.appendChild(body);
  }
});

// End of judgme app 
// Klaviyo trigger on Get 20% off button
window.onload = function() {

    let klaviyoFormTriggerBtn = document.getElementById('newsletterBar');
    let newsletterModal = document.getElementById('NewsletterModal');
    // Define the function to open the form ( This is a default Klaviyo Trigger form)
    function openForm() {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(['openForm', 'TNWvSD']);
    }

    // Attach the click event handler to the button - Check for the btn 
    if(klaviyoFormTriggerBtn){
      klaviyoFormTriggerBtn.onclick = function() {
        newsletterModal.style.display = "none";
        openForm(); 
    };
    }
};

// End of klaviyo 





